import { computed } from 'vue';
import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';
import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';
import { useInputStore } from '@/features/Sparten';

export const showWertentwicklung = computed(
  () =>
    !getSimpleChoiceMeta(
      SIMPLE_CHOICE.UEBERSCHUSSSYSTEM,
      SIMPLE_CHOICE_META.HIDE_WERTENTWICKLUNG,
    ).includes(useInputStore().ueberschusssystem ?? ''),
);
